import styles from "./Subscription.module.scss";

const addondHeader = [
  "Feature",
  "Usage Limits",
  "Price per Package",
  "Total Price",
];

type AddonsProps = {
  data: {
    Feature: string;
    "Usage Limits": JSX.Element;
    "Price per Package": JSX.Element;
    "Total Price": JSX.Element;
  }[];
};

const Addons = ({ data }: AddonsProps) => {
  return (
    // @ts-expect-error TS2339 non-existing className
    <table className={styles.table}>
      <thead>
        <tr>
          {addondHeader.map((header) => (
            <th key={header}>{header}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data?.map((row, index) => (
          <tr key={index}>
            {addondHeader?.map((header) => (
              <td key={header}>
                {row?.[header as keyof typeof row] as string}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
export default Addons;
